import { render, staticRenderFns } from "./ChooseSystem.vue?vue&type=template&id=51da0cd7"
import script from "./ChooseSystem.vue?vue&type=script&lang=js"
export * from "./ChooseSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports